import { render } from "./filter-section.vue?vue&type=template&id=5b65c0d6&scoped=true&ts=true"
import script from "./filter-section.vue?vue&type=script&lang=ts"
export * from "./filter-section.vue?vue&type=script&lang=ts"

import "./filter-section.vue?vue&type=style&index=0&id=5b65c0d6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b65c0d6"]])

export default __exports__